import { formatPrice } from "./format";
import { useLocale } from "@/i18n";

export default function BottomBar({ service, step, submitting, onContinue, formId }) {
  const { t, locale } = useLocale();
  const LABELS = [t("continue"), t("continue"), t("confirm_booking")];

  const btnProps =
    step === 2
      ? { type: "submit", form: formId, disabled: submitting }
      : { type: "button", onClick: onContinue };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 backdrop-blur-xl bg-zinc-950/80 border-t border-zinc-800 shadow-xl shadow-black/50" data-testid="bottom-bar">
      <div className="w-full max-w-md mx-auto px-4 py-4 flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="text-xs text-zinc-500 truncate">
            {service ? service.name : t("select_service")}
          </p>
          <p className="text-xl font-bold text-zinc-50" data-testid="bottom-bar-price">
            {service ? formatPrice(service.price, locale) : "—"}
          </p>
        </div>
        <button
          {...btnProps}
          data-testid="continue-btn"
          className="shrink-0 h-12 px-8 rounded-lg bg-amber-500 text-zinc-950 font-bold hover:bg-amber-400 transition-colors active:scale-95 disabled:opacity-60"
        >
          {submitting ? t("booking_in_progress") : LABELS[step]}
        </button>
      </div>
    </div>
  );
}
